import React from "react";
import "../../assets/scss/home.scss";
import HomeHeader from "./HomeHeader";
import InvestHappiness from "./InvestHappiness";
import OurClient from "./OurClient";
import SubscribeNewsletter from "./SubscribeNewsletter";
import StrategicPartners from "./StrategicPartners";
import DarkFooter from "components/DarkFooter";
import IndexNavbar from "components/IndexNavbar";

import ScrollToTop from "react-scroll-to-top";
import { FaAngleUp } from "react-icons/fa";

const Home = () => {

    return (
        <>
            <IndexNavbar />
            <div className="homepage">
                <HomeHeader />
                <InvestHappiness />
                <OurClient />
                <SubscribeNewsletter />
                <StrategicPartners />
            </div>
            <DarkFooter />
            <ScrollToTop smooth className="backToTopBtn" style={{ background: "linear-gradient(180deg, #1F4C8E -113%, #001550 190.5%)"}} component={<div><FaAngleUp className="scrollTopIcon" color="#fff" /></div>} />
        </>
    );
};

export default Home;
